/* @flow */
import React from "react";
import { Route, Switch } from "react-router";
import AppMeta from "./AppMeta";
import { CBDView, Errors } from "../components";

class App extends React.Component<{}> {
  render() {
    return (
      <div>
        <div>
          <AppMeta />
          <Switch>
            <Route path="/cbd" component={CBDView} />
            <Route component={Errors} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js